import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const ServicesListWrapper = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(16)};
    flex-direction: column;
  }
`;
export const ServiceElement = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
  }
`;

export const ServiceWrapperLi = styled.div`
  &&& {
    box-shadow: ${({ theme }) => theme.elevations['3']};
  }
`;

export const TitleWrapper = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
    justify-content: flex-start;
    align-items: center;
    margin-top: ${pxToRem(8)};
    padding: ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(16)};
    box-shadow: ${({ theme }) => theme.elevations['3']};
  }
`;

export const ServicesListSection = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
  }
`;

export const TooltipContent = styled.div`
  &&& {
    padding: ${pxToRem(24)};
    max-width: ${pxToRem(300)};
  }
`;
